export default __webpack_public_path__ + "static/media/API.b2f4d224.png";